module.exports = __webpack_public_path__ + "08abac8179d06a2a7f7aed9a6195a8cd.png";


//////////////////
// WEBPACK FOOTER
// ./lib/provider/resources/img/logo-batiref.png
// module id = 1828
// module chunks = 0